module.exports = __webpack_public_path__ + "static/img/lb10.356a0b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb10.png
// module id = SIgr
// module chunks = 0